import React, { useState} from "react";
import {graphql} from "gatsby";
import PostLink from "cube-components/blog/PostLink";
import Pagination from "cube-components/blog/Pagination";
import MagentoConsultingBanner from "cube-components/cta/MagentoConsultingBanner";
import Seo from "cube-components/Seo";
import PageLayout from "cube-components/PageLayout";
import Heading from "cube-components/ui/Heading";
import TagsView from "../cube-components/blog/TagsView";

const PostList = result => {
    const {data, pageContext} = result;
    const {allMarkdownRemark} = data;
    const {edges} = allMarkdownRemark;
    const [consultingVisible, setConsultingVisible] = useState(true);

    const Posts = edges
        .map(edge => <PostLink key={edge.node.id}
                               post={edge.node}
        />);

    const tags: string[] = ["magento2", "ar", "use-case", "tutorials", "pwa", "security"];

    return (
        <PageLayout>
            <section className="relative border-t border-lucid-800">
                <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
                    <div className="pt-32 md:pt-40">
                        <div className="max-w-3xl mx-auto text-center">
                            <Heading title="Lucid Modules Blog"
                                     subtitle="Discover solutions for Magento 2 merchants. Explore ecommerce, augmented reality, and web technologies."
                            />

                            {consultingVisible && (
                                <MagentoConsultingBanner onClose={() => setConsultingVisible(false)}/>
                            )}
                            <TagsView tags={tags}/>
                            <div className="flex flex-col gap-5">{Posts}</div>
                            <Pagination pageContext={pageContext}
                                        paginationUrl={"/blog"}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
};

export default PostList;

export const Head = ({pageContext}) => {
    const {currentPage} = pageContext;
    let pageSuffix = "";
    if (currentPage > 1) {
        pageSuffix = " | page " + currentPage;
    }

    const meta = ({
        title:
            "Read about Magento 2 and Web Technologies | Lucid Modules" +
            pageSuffix,
        description:
            "Discover solutions for Magento 2 merchants. Explore ecommerce, augmented reality, and web technologies." +
            pageSuffix,
        keywords:
            "magento2, pwa, tutorials, magento 2 blog, augmented reality blog, ar"
    });

    return <Seo lang="en"
                meta={meta}
    />;
};

export const pageQuery = graphql`
    query pageQuery($skip: Int!, $limit: Int!) {
        allMarkdownRemark(
            sort: { frontmatter: { date: DESC } }
            limit: $limit
            skip: $skip
            filter: { frontmatter: { status: { eq: "published" } } }
        ) {
            edges {
                node {
                    id
                    frontmatter {
                        date(formatString: "MMMM DD, YYYY")
                        slug
                        title
                        description
                        featuredImage {
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
        }
    }
`;
